/*
 *   Copyright 2022  SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { h, Host } from "@stencil/core";
export class DiscoverySpinner {
    constructor() {
        this.message = 'Loading...';
    }
    componentDidLoad() {
        this.message = this.el.innerText || this.message;
    }
    render() {
        return (h(Host, { key: '617b18a85683ff7e360bc50c112ffcb4268dac71' }, h("div", { key: '6bf3674a0d1a78f1496709b1b5bbf654b1a13ebb', class: "loader" }), h("span", { key: 'abdbc8aad4c21f293a1eb9eb3b09910090f7bf0f', class: "message" }, this.message), h("span", { key: '0561cd56d5ab02f09f81ea3748759fec1dcaf4c1', class: "hidden" }, h("slot", { key: '94da956abaf6c1ee367dd62ec766ac7e9e3dcb3c' }))));
    }
    static get is() { return "discovery-spinner"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["discovery-spinner.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["discovery-spinner.css"]
        };
    }
    static get properties() {
        return {
            "message": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "message",
                "reflect": false,
                "defaultValue": "'Loading...'"
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=discovery-spinner.js.map
